"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fragments_1 = require("../fragments");
const notifi_axios_utils_1 = require("@notifi-network/notifi-axios-utils");
const DEPENDENCIES = [...fragments_1.smsTargetFragmentDependencies, fragments_1.smsTargetFragment];
const MUTATION = `
mutation createSmsTarget(
  $name: String!
  $value: String!
) {
  createSmsTarget(
    createTargetInput: {
      name: $name
      value: $value
    }
  ) {
    ...smsTargetFragment
  }
}
`.trim();
const createSmsTargetImpl = (0, notifi_axios_utils_1.makeRequest)((0, notifi_axios_utils_1.collectDependencies)(...DEPENDENCIES, MUTATION), 'createSmsTarget');
exports.default = createSmsTargetImpl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3JlYXRlU21zVGFyZ2V0SW1wbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL2xpYi9tdXRhdGlvbnMvY3JlYXRlU21zVGFyZ2V0SW1wbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLDRDQUFnRjtBQUNoRiwyRUFHNEM7QUFNNUMsTUFBTSxZQUFZLEdBQUcsQ0FBQyxHQUFHLHlDQUE2QixFQUFFLDZCQUFpQixDQUFDLENBQUM7QUFFM0UsTUFBTSxRQUFRLEdBQUc7Ozs7Ozs7Ozs7Ozs7O0NBY2hCLENBQUMsSUFBSSxFQUFFLENBQUM7QUFFVCxNQUFNLG1CQUFtQixHQUFHLElBQUEsZ0NBQVcsRUFHckMsSUFBQSx3Q0FBbUIsRUFBQyxHQUFHLFlBQVksRUFBRSxRQUFRLENBQUMsRUFBRSxpQkFBaUIsQ0FBQyxDQUFDO0FBRXJFLGtCQUFlLG1CQUFtQixDQUFDIn0=